<template>
  <component
    :is="menuComponent"
    v-if="!item.hidden"
    :item="item"
    :route-children="routeChildren"
  >
    <template v-if="item.children && item.children.length">
      <hhxc-menu
        v-for="route in item.children"
        :key="route.path"
        :item="route"
      ></hhxc-menu>
    </template>
  </component>
</template>

<script>
  import MenuItem from './components/MenuItem'
  import Submenu from './components/Submenu'

  import { reactive, toRefs } from 'vue'
  export default {
    name: 'HhxcMenu',
    components: { MenuItem, Submenu },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    setup(props) {
      const myData = reactive({
        routeChildren: {},
        menuComponent: '',
      })
      let handleChildren = (children = []) => {
        if (children === null) return []
        return children.filter((item) => item.hidden !== true)
      }
      const showChildren = handleChildren(props.item.children)
      if (showChildren.length === 0) {
        myData.menuComponent = 'MenuItem'
        myData.routeChildren = props.item || {}
      } else if (showChildren.length === 1 && props.item.alwaysShow !== true) {
        myData.menuComponent = 'MenuItem'
        myData.routeChildren = showChildren[0]
      } else {
        myData.menuComponent = 'Submenu'
      }
      return {
        ...toRefs(myData),
      }
    },
  }
</script>
<style lang="less">
  .anticon {
    margin-right: 3px !important;
  }
</style>
